import React from 'react';

import { Icon } from '@chakra-ui/react';

export const TicketIcon = props => (
  <Icon viewBox="0 0 256 256" color="inherit" h="full" w="full" {...props}>
    <path
      fill="none"
      stroke={props?.stroke || 'currentColor'}
      strokeWidth={props?.strokeWidth || 12}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M226.39648,100.56006A12.02757,12.02757,0,0,0,236,88.80957V64a12.01312,12.01312,0,0,0-12-12H32A12.01312,12.01312,0,0,0,20,64V88.80957a12.02757,12.02757,0,0,0,9.60352,11.75049,28.00781,28.00781,0,0,1,0,54.87988A12.02757,12.02757,0,0,0,20,167.19043V192a12.01312,12.01312,0,0,0,12,12H224a12.01312,12.01312,0,0,0,12-12V167.19043a12.02757,12.02757,0,0,0-9.60352-11.75049,28.00781,28.00781,0,0,1,0-54.87988ZM28,192V167.19043a4.00211,4.00211,0,0,1,3.19531-3.91016,36.00816,36.00816,0,0,0,0-70.56054A4.00211,4.00211,0,0,1,28,88.80957V64a4.00427,4.00427,0,0,1,4-4H92V196H32A4.00427,4.00427,0,0,1,28,192Zm168-64a36.0982,36.0982,0,0,0,28.80469,35.28027A4.00211,4.00211,0,0,1,228,167.19043V192a4.00427,4.00427,0,0,1-4,4H100V60H224a4.00427,4.00427,0,0,1,4,4V88.80957a4.00211,4.00211,0,0,1-3.19531,3.91016A36.0982,36.0982,0,0,0,196,128Z"
    />
  </Icon>
);
